// extracted by mini-css-extract-plugin
export default {"approveButton":"ApproveUsersTable_approveButton__F657t","rejectButton":"ApproveUsersTable_rejectButton__qZCZw"};